import { ComponentSync } from '@nu-art/thunderstorm-frontend';
import { ToastItemStatus } from '../../types.js';
import { ModuleFE_Toasting } from '../../../_core/ModuleFE_Toasting.js';
export class ToasterPortal extends ComponentSync {
    static defaultProps = {
        modelFilter: () => true,
    };
    // ######################### Life Cycle #########################
    __onToastingModelsChange = () => {
        const { toAdd, toRemove } = this.inferItems();
        if (!toAdd.length && !toRemove.length)
            return;
        //Send data to portal implementation
        this.handleModelChanges(toAdd, toRemove);
    };
    deriveStateFromProps(nextProps, state) {
        state.items ??= [];
        return state;
    }
    // ######################### Internal Logic #########################
    inferItems = () => {
        const allModels = ModuleFE_Toasting.getModels();
        const existingModelIds = new Set(this.state.items.map(i => i.model.id));
        const allModelIds = new Set(allModels.map(m => m.id));
        //Calculate which models to add, and which models to remove
        const itemsToAdd = allModels.filter(model => !existingModelIds.has(model.id) && this.props.modelFilter(model)).map(model => ({
            model,
            status: ToastItemStatus.Loaded
        }));
        const itemsToRemove = this.state.items.filter(item => !allModelIds.has(item.model.id));
        return { toAdd: itemsToAdd, toRemove: itemsToRemove, };
    };
    handleModelChanges(toAdd, toRemove) {
        //Start out new items as a combination of the current items and the ones to add.
        const newItems = toAdd.length ? [...this.state.items, ...toAdd] : [...this.state.items];
        if (toRemove.length) { //Update each item to remove
            const toRemoveIds = new Set(toRemove.map(i => i.model.id));
            newItems.forEach(item => {
                if (toRemoveIds.has(item.model.id))
                    item.status = ToastItemStatus.Closed;
            });
            //Trigger timer for item removal from the array
            setTimeout(() => {
                const items = this.state.items.filter(i => !toRemoveIds.has(i.model.id));
                this.setState({ items });
            }, 200);
        }
        this.setState({ items: newItems });
    }
    reportConsumeModel = (id) => ModuleFE_Toasting.toast.process(id);
}
//# sourceMappingURL=ToasterPortal.js.map